const settle = {
  'settle.title': '结算单',
  'settle.goSettle': '去结算',
  'settle.productInfo': '商品信息',
  'settle.table.column.index': '序号',
  'settle.table.column.image': '商品图',
  'settle.table.column.detail': '配件详情',
  'settle.table.column.replaceNumber': '替换号',
  'settle.table.column.price': '价格',
  'settle.table.column.quantity': '数量',
  'settle.selected': '已选商品{count}件',
  'settle.totalQuantity': '合计数量{quantity}件',
  'settle.goToOrder': '去下单',

  'settle.deliveryMethod': '发货要求',
  'settle.deliveryMethod.placeholder': '请选择发货要求',
  'settle.deliveryMethod.normal': '标准',
  'settle.deliveryMethod.normal.desc': '一般陆运渠道',
  'settle.deliveryMethod.urgent': '加急',
  'settle.deliveryMethod.urgent.desc': '加急订单将优先处理并安排空运发货，时效更快，费用相应增加',

  // 表单验证和操作提示
  'settle.form.validation.error': '请检查表单输入项',
  'settle.address.required': '请选择收货地址',
  'settle.product.required': '请至少选择一件商品',
  'settle.order.submitting': '下单中...',
  'settle.order.success': '下单成功',
  'settle.order.failed': '下单失败',
  'settle.order.retry': '下单失败，请重试',

  'settle.message.invalidSelectedProducts': '有商品数量不符合要求符合要求，请检查',

  'settle.order.failedModal.title': '下单失败，表格中商品的数量不符合要求',
  'settle.order.failedModal.content':
    '商品数量必须大于起订量，且为整倍销售数量的倍数。请修改下单数量后重新下单。',
  'settle.order.failedModal.product': '商品名称',
  'settle.order.failedModal.quantity': '当前数量',
  'settle.order.failedModal.min_sale_count': '起订量',
  'settle.order.failedModal.multiple_sale_count': '整倍销售数量',
  'settle.order.failedModal.error_message': '错误信息',
};

export default settle;
